(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/place-bet/place-bet-new-payment-flow.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/place-bet/place-bet-new-payment-flow.js');
"use strict";


const logger = new svs.core.log.Logger('svs.sport.QuickplayModal.placeBetNewPayment');
const {
  getDisplayName,
  resolveITSProductId
} = svs.utils.products;
const {
  isMarketplaceWallet
} = svs.components.tipsen.wallet.walletHelpers;
const {
  createStandardPaymentFlow
} = svs.components.wagerPaymentFlow.standardFlow;
const {
  createMarketplacePaymentFlow
} = svs.components.wagerPaymentFlow.marketplaceFlow;
const {
  WALLET_MARKETPLACE_PLAYER,
  WALLET_MARKETPLACE_RETAILER
} = svs.components.tipsen.wallet.walletType;
const {
  groupTypes
} = svs.components.marketplaceData.constants;
const getReturnQuery = () => Object.fromEntries(new URLSearchParams(window.location.search).entries());
const executePayment = function () {
  return svs.components.wagerPaymentFlow.executePayment.executePayment(...arguments);
};
const getGroupType = type => {
  switch (type) {
    case WALLET_MARKETPLACE_PLAYER:
      return groupTypes.PRIVATE;
    case WALLET_MARKETPLACE_RETAILER:
      return groupTypes.RETAILER;
    default:
      logger.info("unsupported group type: ".concat(type));
  }
};


const createAndExecutePayment = async _ref => {
  let {
    productId,
    bag,
    closeCallback,
    hasMarketplaceWallet,
    unlockPaymentFlow,
    isPixMix,
    wallet,
    wagerToPay,
    handleRedirect,
    setKeepOpenItem
  } = _ref;
  const pixHandler = svs.components.sport.pixHandler.getPixHandler({
    isPixMix
  });
  let paymentBuilder;
  const _successCallback = async () => {
    await pixHandler.fetch({
      productId,
      shouldGenerateNewPix: true
    });
    if (closeCallback) {
      closeCallback();
    }
    handleRedirect();
  };
  if (hasMarketplaceWallet) {
    const walletMeta = wallet === null || wallet === void 0 ? void 0 : wallet.meta;
    const role = getGroupType(wallet.type);
    const isC2C = Boolean(role === groupTypes.PRIVATE);
    wagerToPay.setRole(role);
    if (isC2C) {
      wagerToPay.setActivatedDrawId(walletMeta.activatedDrawId);
    } else {
      wagerToPay.setActivatedDrawId(walletMeta.activatedDrawId);
      wagerToPay.setCommissionPercent(walletMeta.commissionPercent);
    }
    paymentBuilder = createMarketplacePaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wagerToPay],
      isC2C
    });
  } else {
    paymentBuilder = createStandardPaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wagerToPay]
    });
  }
  if (setKeepOpenItem) {
    const {
      systemCost,
      systemType,
      drawNumber,
      rowPrice,
      productSizes,
      branding
    } = pixHandler.getProduct(productId);
    pixHandler.setKeepOpenItem({
      url: svs.utils.url.makeInternal("".concat(window.location.pathname).concat(window.location.search || '')),
      pixData: {
        productId,
        systemCost,
        systemType,
        rowPrice,
        drawNumber,
        productSizes,
        branding,
        isPixMix
      }
    });
  }
  const [, error] = await executePayment(paymentBuilder, {
    userContext: {
      bag,
      returnQuery: getReturnQuery()
    }
  });
  unlockPaymentFlow();
  if (!error) {
    await _successCallback();
  }
};

const placeBetNewPaymentFlow = async _ref2 => {
  let {
    productId,
    closeCallback,
    unlockPaymentFlow,
    wallet,
    isPixMix,
    handleRedirect,
    subProductId,
    setKeepOpenItem
  } = _ref2;
  const productName = getDisplayName(productId);
  if (!productName) {
    unlockPaymentFlow();
    logger.error("Error in placeBet: Invalid productId (".concat(productId, ")"));
    return;
  }
  const pixHandler = svs.components.sport.pixHandler.getPixHandler({
    isPixMix
  });
  const {
    systemCost
  } = pixHandler.getProduct(productId);
  const bag = "".concat(systemCost, ":").concat(productName, " ").concat(systemCost);
  const wagerToPay = pixHandler.createPixWager({
    productId,
    subProductId
  });
  const wagerProductId = resolveITSProductId(productId) || '';
  if (!wagerProductId) {
    logger.info('Warning in placeBetNewPaymentFlow: Sending wager without productID');
  }
  const hasMarketplaceWallet = isMarketplaceWallet(wallet);
  return createAndExecutePayment({
    productId,
    bag,
    closeCallback,
    hasMarketplaceWallet,
    unlockPaymentFlow,
    isPixMix,
    wallet,
    wagerToPay,
    handleRedirect,
    setKeepOpenItem
  });
};
setGlobal('svs.components.sport.quickplayModal.placeBet.placeBetNewPaymentFlow', placeBetNewPaymentFlow);

 })(window);